import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { BaseAlert } from '@app/components/common/BaseAlert/BaseAlert';
import { useAppSelector } from '@app/hooks/reduxHooks';
import dayjs from 'dayjs';
import * as S from './TemporaryPasswordBanner.styles';

export const TemporaryPasswordBanner: React.FC = () => {
  const { t } = useTranslation();
  const userData = useAppSelector((state) => state.user.userData);

  const isTemporaryPasswordActive = userData?.temporary_password_active === true;
  const expiresAt = userData?.temporary_password_expires_at;

  if (!isTemporaryPasswordActive) {
    return null;
  }

  const formatExpiresAt = (timestamp: string | null | undefined): string => {
    if (!timestamp) {
      return '';
    }
    try {
      return dayjs(timestamp).format('YYYY-MM-DD HH:mm');
    } catch {
      return timestamp;
    }
  };

  const expiresAtFormatted = formatExpiresAt(expiresAt);
  const message = expiresAtFormatted
    ? t('adminusers.bannerMessageWithExpiry', { expiresAt: expiresAtFormatted })
    : t('adminusers.bannerMessage');

  return (
    <S.BannerWrapper>
      <BaseAlert
        type="error"
        message={
          <S.BannerContent>
            <S.BannerText>{message}</S.BannerText>
            <S.BannerLink to="/change-password">{t('adminusers.changePasswordLink')}</S.BannerLink>
          </S.BannerContent>
        }
        showIcon
        closable={false}
      />
    </S.BannerWrapper>
  );
};


